import styled from 'styled-components';

import { Color } from '../../../constants/Colors';
import { MediaQuery } from '../../../constants/Styles';
import { Typography } from '../../../constants/Typographies';

export const TableOfContent = styled.div`
  margin-top: 50px;
  border-radius: 30px;

  li {
    padding-bottom: 15px;
  }

  li::marker {
    color: ${Color.CLOUD_BURST};
  }

  ${MediaQuery.M_AND_DOWN} {
    padding: 15px;
    margin: 30px 15px;
  }
`;

export const Title = styled.h2`
  ${Typography.XXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  padding-bottom: 30px;
`;
